'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _config = _interopRequireDefault(require("Shared/config"));
var _Account = _interopRequireDefault(require("Icons/Account"));
var _LogoutIcon = _interopRequireDefault(require("Icons/LogoutIcon"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
var _Link = _interopRequireDefault(require("Pure/Link"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  app,
  qwest
} = window;
class UserMenu extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      open: false,
      roles: []
    });
    (0, _defineProperty2.default)(this, "handleSessionChange", _ref => {
      var _app$state$session$us;
      let {
        source,
        data = {}
      } = _ref;
      const component = this,
        props = this.props,
        state = this.state;
      if (!((_app$state$session$us = app.state.session.user) !== null && _app$state$session$us !== void 0 && _app$state$session$us.id)) return;
      component.setState({
        roles: app.state.session.user.roles || []
      });
    });
    (0, _defineProperty2.default)(this, "handleDocClick", _ref2 => {
      let {
        source,
        data = {}
      } = _ref2;
      const component = this,
        props = this.props,
        state = this.state;
      if (source === 'UserMenu') return;
      component.setState({
        open: false
      });
    });
    (0, _defineProperty2.default)(this, "toggleAccount", e => {
      const component = this,
        props = this.props,
        state = this.state;
      e.stopPropagation();
      app.emit({
        event: 'documentClick',
        source: 'UserMenu'
      });
      component.setState({
        open: !state.open
      });
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'documentClick',
      cb: component.handleDocClick
    });
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    component.handleSessionChange({
      source: 'DidMount'
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'documentClick',
      cb: component.handleDocClick
    });
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  render() {
    var _app$state$session$us2;
    const component = this,
      props = this.props,
      state = this.state;
    let modifiers = (state.open ? ['open'] : []).concat(props.bemit || []);
    const is__admin = state.roles.includes('admin');
    const my_account_url = (0, _Routing.URL)('UpdateUser').replace(':id', (_app$state$session$us2 = app.state.session.user) === null || _app$state$session$us2 === void 0 ? void 0 : _app$state$session$us2.id);
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _bemit.default)('c-user-menu', modifiers)
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "button",
      className: "c-user-menu__toggle",
      "aria-label": "Menu utilisateur",
      onClick: component.toggleAccount
    }, /*#__PURE__*/_react.default.createElement(_Account.default, {
      className: "c-user-menu__icon"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-user-menu__menu"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "c-user-menu__menu-item",
      href: my_account_url,
      rel: "noopener noreferrer",
      component: my_account_url === document.location.pathname ? undefined : _Link.default
    }, "Mon compte"), /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "c-user-menu__menu-item",
      onClick: props.requestLogout
    }, /*#__PURE__*/_react.default.createElement(_LogoutIcon.default, {
      className: "c-user-menu__menu-icon"
    }), "D\xE9connexion")), /*#__PURE__*/_react.default.createElement("div", {
      className: "app-version"
    }, "v.", _config.default.js_version));
    return output;
  }
}
exports.default = UserMenu;
